import { visionLabApi } from '@/app/apiClient';
import { VIDEO_PAGE_LIMIT } from '@/features/video/config/constants';
import type { VideoSegmentPage } from '@/features/video/types/contracts';
import type { ApiCallOptions } from '@/shared/api/client';

/**
 * One page of an asset's clips (`GET /assets/:assetId/segments`).
 *
 * Asked for at the backend's maximum page size, which is far above any plausible
 * clip count on a single asset, so in practice this one request *is* the whole
 * list — hence no cursor threading and no infinite query. `nextCursor` is still
 * returned so a caller can tell that it was truncated rather than assume it
 * wasn't; pass it to the endpoint's `cursor` param if a paged view ever needs it.
 */
export async function fetchVideoSegmentPage(
  assetId: string,
  { cursor }: { cursor?: string } = {},
  options: ApiCallOptions = {},
): Promise<VideoSegmentPage> {
  return visionLabApi.get<VideoSegmentPage>(`/assets/${encodeURIComponent(assetId)}/segments`, {
    ...options,
    searchParams: { limit: VIDEO_PAGE_LIMIT, cursor: cursor || undefined },
  });
}
